/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Empty_ContactInputs */

const en_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us`)
};

const es_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos`)
};

const de_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktieren Sie uns`)
};

const zh_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

const ar_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل معنا`)
};

const fr_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactez-nous`)
};

const vi_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ chúng tôi`)
};

const sw_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasiliana nasi`)
};

const th_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อเรา`)
};

const bs_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktirajte nas`)
};

const ja_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const ko_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의하기`)
};

const pt_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fale conosco`)
};

const it_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contattaci`)
};

const sv_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakta oss`)
};

const nl_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacteer ons`)
};

const da_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt os`)
};

const nb_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resepter`)
};

const fi_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä`)
};

const pl_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skontaktuj się z nami`)
};

const ru_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свяжитесь с нами`)
};

const tr_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bize ulaşın`)
};

const hi_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमसे संपर्क करें`)
};

const id_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami`)
};

const ms_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami`)
};

const cs_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`,`)
};

const el_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικοινωνήστε μαζί μας`)
};

const he_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו איתנו קשר`)
};

const af_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakeer ons`)
};

const hu_practice_empty_contact = /** @type {(inputs: Practice_Empty_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lépjen kapcsolatba velünk.`)
};

/**
* | output |
* | --- |
* | "Contact us" |
*
* @param {Practice_Empty_ContactInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_empty_contact = /** @type {((inputs?: Practice_Empty_ContactInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Empty_ContactInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_empty_contact(inputs)
	if (locale === "de") return de_practice_empty_contact(inputs)
	if (locale === "zh") return zh_practice_empty_contact(inputs)
	if (locale === "ar") return ar_practice_empty_contact(inputs)
	if (locale === "fr") return fr_practice_empty_contact(inputs)
	if (locale === "vi") return vi_practice_empty_contact(inputs)
	if (locale === "sw") return sw_practice_empty_contact(inputs)
	if (locale === "th") return th_practice_empty_contact(inputs)
	if (locale === "bs") return bs_practice_empty_contact(inputs)
	if (locale === "ja") return ja_practice_empty_contact(inputs)
	if (locale === "ko") return ko_practice_empty_contact(inputs)
	if (locale === "pt") return pt_practice_empty_contact(inputs)
	if (locale === "it") return it_practice_empty_contact(inputs)
	if (locale === "sv") return sv_practice_empty_contact(inputs)
	if (locale === "nl") return nl_practice_empty_contact(inputs)
	if (locale === "da") return da_practice_empty_contact(inputs)
	if (locale === "nb") return nb_practice_empty_contact(inputs)
	if (locale === "fi") return fi_practice_empty_contact(inputs)
	if (locale === "pl") return pl_practice_empty_contact(inputs)
	if (locale === "ru") return ru_practice_empty_contact(inputs)
	if (locale === "tr") return tr_practice_empty_contact(inputs)
	if (locale === "hi") return hi_practice_empty_contact(inputs)
	if (locale === "id") return id_practice_empty_contact(inputs)
	if (locale === "ms") return ms_practice_empty_contact(inputs)
	if (locale === "cs") return cs_practice_empty_contact(inputs)
	if (locale === "el") return el_practice_empty_contact(inputs)
	if (locale === "he") return he_practice_empty_contact(inputs)
	if (locale === "af") return af_practice_empty_contact(inputs)
	if (locale === "hu") return hu_practice_empty_contact(inputs)
	return en_practice_empty_contact(inputs)
});